import React from 'react'
import Tooltip from 'components/Tooltip'
import AlertIcon from 'assets/icons/alert-icon-question'
import { IconWrapper, CustomOverlay } from './style'

const AlertIconQuestion = ({ title }) => {
  if (!title) {
    return (
      <IconWrapper style={{ display: 'none' }}>
        <AlertIcon />
      </IconWrapper>
    )
  }

  return (
    <Tooltip
      placement="top"
      trigger={['hover']}
      kbaCriteria
      overlay={{ custom: <CustomOverlay>{title}</CustomOverlay> }}
    >
      <IconWrapper style={{ display: 'none' }}>
        <AlertIcon />
      </IconWrapper>
    </Tooltip>
  )
}

export default AlertIconQuestion
